export default {"src":"/_next/static/media/ollie-logo-inline.091c27e7.svg","height":39,"width":79,"blurWidth":0,"blurHeight":0};